export default {
  taskTitList: ['校考考试', '联考考试'],
  year: '学年学期',
  grade: '年级',
  examType: '考试类型',
  examName: '考试名称',
  ji: '级',
  shouqi: '收起',
  zhankai: '展开',
  examTime: '考试时间',
  unPuSub: '未发布学科',
  clear: '清理',
  isSchool: '学校可见',
  isRank: '排名可见',
  isParent: '家长可见',
  isStudent: '学生查询成绩',
  downAll: '考试整体分析表下载',
  downOne: '独立分析表下载',
  comparison: '数据对比',
  downSelf: '下载个性报表',
  studentCount: '考试人数',
  totalScore: '总分',
  avgScore: '平均分',
  maxScore: '最高分',
  minScore: '最低分',
  overAverageRate: '超均率',
  overAverageNumber: '超均人数',
  standardDeviation: '标准差',
  difficulty: '难度',
  discrimination: '区分度',
  DataContrast: '选择历次考试数据对比考试',
  testName: '当前考试名称',
  derectTest: '直接对比考试',
  inderectTest: '直接对比考试',
  derectTip:
    '表格中会把当前考试与该次考试的成绩进行直接对比，得出学生进退步及班级（年级）维度的升降数据。',
  inderectTip:
    '表格中会把当前考试与所选考试的成绩进行间接对比，得出学生进退步及班级（年级）维度的升降数据。',
  placeholder1: '请选择直接对比考试',
  placeholder2: '请选择间接对比考试',
  studentTitle: '学生查询地址',
  studentCan: '学生可见',
  studentCanTip: '学生可以通过访问本地址且登录后查询本次考试总分及各学科成绩',
  lang: '选择语言',
  searchLink: '查询地址',
  copy: '复制',
  langList: ['简体', '繁体'],
  examTypeList: [
    '全部',
    '练习',
    '周考',
    '月考',
    '期中考试',
    '期末考试',
    '模拟考试'
  ],
  meTypeList: ['所有考试', '全科', '文科', '理科'],
  gradeList: ['全部'],
  examList: ['所有考试'],
  examGradeList: [
    '一年级',
    '二年级',
    '三年级',
    '四年级',
    '五年级',
    '六年级',
    '初一',
    '初二',
    '初三',
    '高一',
    '高二',
    '高三'
  ],
  copysucess: '查询地址已复制到粘贴板',
  ztsucess: '状态修改成功',
  sucess: '修改成功',
  hcsucess: '缓存清理成功',
  directExam: '间接对比考试最多选择两场考试！',
  unallcourse: '全科并没有全部发布成绩，暂时没有数据！',
  doenFail: '下载失败',
  allCourse: '全科',
  meExamType: [
    '练习考试',
    '周考试',
    '月考试',
    '期中考试',
    '期末考试',
    '模拟考试'
  ],
  //全科和单科页面
  seNameTit: '_数据报表',
  label1: '所属校区',
  label2: '组别',
  label3: '班级',
  label4: '考试科目',
  alertText:
    '本科目所有题块未批阅完成，由于您提前汇总、发布了成绩，所以下述报表不一定是完整的，请知晓~',
  fen: '分',
  ren: '人',
  toptext1: '卷面满分',
  toptext2: '难度值',
  toptext3: '区分度',
  gradeTit: ['年', '级', '概', '况'],
  classTit: ['班', '级', '概', '况'],
  topList: [
    '年级参考',
    '年级最高分',
    '年级最低分',
    '年级均分',
    '年级超均率',
    '年级标准差'
  ],
  classtopList: [
    '班级参考',
    '班级最高分',
    '班级最低分',
    '班级均分',
    '班级超均率',
    '班级标准差'
  ],
  notTabel: '暂无报表',
  overview1Tit: '均分离差分析',
  downbtn: '下载',
  biao: '表',
  className: '班级',
  name: '姓名',
  classGroup: '班型',
  AvgScore: '平均分',
  BValue: 'B值',
  GradeRank: '年级排名',
  GroupRank: '同层排名',
  GroupScore: '同层分差',
  studentNum: '参考人数',
  ClassTeacher: '班主任',
  teacher: '教师',
  sortListTotal: [
    '学生成绩散点图',
    '学生成绩单',
    '四分位分析',
    '均分分析',
    '均分离差分析',
    '四率分析',
    '分数线分析',
    '分数段分析',
    '位次段分析',
    '试卷整体分析',
    '试题得分趋势',
    '试题得分表',
    '试题作答明细'
  ],
  contrastNav: ['学生进退步', '均分分析对比', '分数线分析对比'],
  schoolNav: [
    '小分表',
    '题目层次得分率',
    '题目层次得分率对比',
    '学生层次错题表'
  ],
  sing: {
    downchart: '下载分析图',
    exp: [
      '',
      '双上线率=双上线人数/参考人数',
      '学科命中率=双上线人数/单科上线人数',
      '学科贡献率=双上线人数/总分上线人数'
    ]
  },
  singSub: '单科',
  singsubScore: '单科成绩',
  studentPointChart: '线性回归',
  finalScore: '最终成绩单',
  scoreLine1: '前25%分数线',
  scoreLine2: '前50%分数线',
  scoreLine3: '前75%分数线',
  scoreNum: '分数',
  titleschool: '学校',
  average: '平均值',
  overviewScore: '离均分差',
  unionRank: '联考排名',
  rateTitle: '比例(%)',
  peopleNum: '人数',
  ranking: '排名',
  twoN: '双N',
  chartCtitle: ['双%', '双%', '命中', '贡献'],
  titArr: [
    { linetitle: '单上线率', barTitle: '单上线人数' },
    { linetitle: '双上线率', barTitle: '双上线人数' },
    { linetitle: '学科命中率', barTitle: '双上线人数' },
    { linetitle: '学科贡献率', barTitle: '双上线人数' }
  ],
  rankSeg: '位次',
  unionTitle: '联考',
  scoreRate: '得分率',
  scoreRate1: '得分率(%)',
  chartMolum: [
    '题型',
    '题号',
    '参考人数',
    '满分',
    '均分',
    '难度',
    '标准差',
    '最高分',
    '最低分',
    '满分N',
    '满分(%)',
    '部分N',
    '部分(%)',
    '零分N',
    '零分(%)'
  ],
  chartKolum: [
    '题号',
    '题名',
    '答案',
    '满分',
    '年级平均分',
    '难度值',
    '均分',
    '得分率'
  ],
  scoreTableColum: [
    '班型',
    '班级',
    '姓名',
    '卷面分数',
    '班级排名',
    '年级排名',
    '客观题得分',
    '主观题得分'
  ],
  minScoreColum: ['题目', '题目层次', '平均得分率'],
  quesRateColum: [
    '班级',
    '题目层次',
    '题目',
    '班级平均分',
    '得分率(%)',
    '层次得分率(%)'
  ],
  allStuText: '整体学生',
  qusMOdalTit: '层次错因分析',
  qusModalLabel: '展示条件',
  qustypeList: [
    {
      id: 1,
      name: '按错因展示'
    },
    {
      id: 2,
      name: '按学生展示'
    }
  ],
  qusth: '层次得分率(%)',
  stunameLabel: '学生姓名',
  stunameplac: '请输入学生姓名',
  stuErrorColum: ['姓名', '学科', '题目层次'],
  xiaoyang: '智阅灵析'
}
